<div class="content-loader" style="width: 100%; display: flex; justify-content: center; align-items: center; padding: 1rem">
  <mat-spinner color="primary" diameter="60" mode="indeterminate"></mat-spinner>
</div>
